import { defineStore } from 'pinia';
import axios from 'axios';
import { router } from '@/js/router'
import Toast from './toast';

export const useUserStore = defineStore({
    id: 'user',
    state: () => ({
        user: null,
        token: JSON.parse(localStorage.getItem('token')),
        returnUrl: null
    }),
    actions: {
        async login(username, password) {
            let state = await axios.post(process.env.VUE_APP_BLOCKB_API_URL + 'login', {
                username: username,
                password: password
            })
            .then((response) => {
                this.token = response.data
                localStorage.setItem('token', JSON.stringify(response.data))
                return response.status
            }).catch(error => {
                return error.response.status
            });

            if(state == 200)
                router.push('/')

            return state;
        },
        async requestReset(email) {
            let state = await axios.post(process.env.VUE_APP_BLOCKB_API_URL + 'reset', {
                email: email
            })
            .then((response) => {  
                return response.status
            }).catch(error => {
                return error.response.status
            });

            return state;
        },
        async validateToken(token) {
            let state = axios.get(process.env.VUE_APP_BLOCKB_API_URL + 'reset/confirm/', {params: {reset_id: token}})
            .then((response) => {  
                return response.data.status
            }).catch(error => {
                return 'error'
            });

            return state;
        },
        async newPassword(token, password) {
            let state = await axios.post(process.env.VUE_APP_BLOCKB_API_URL + 'reset/confirm/' + token, {}, { params: {
                password: password
            }})
            .then((response) => {
                if(response.data.status == 'ok') {
                    router.push('/login')
                    Toast.addToast() 
                }
                return response.data.status
            }).catch(error => {
                return error.response.status
            });

            return state
        },
        async updateData(personalData, customerData, walletData) {
            let statePersonal = await axios.patch(process.env.VUE_APP_BLOCKB_API_URL + 'users/personal/', personalData, {
                headers: { Authorization: `Bearer ${this.token}` },
                params: personalData
            })
            .then((response) => {  
                return response.status
            }).catch(error => {
                return error.response.status
            });

            let stateCustomer = await axios.patch(process.env.VUE_APP_BLOCKB_API_URL + 'customers/personal/', customerData, {
                headers: { Authorization: `Bearer ${this.token}` },
                params: customerData
            })
            .then((response) => {  
                return response.status
            }).catch(error => {
                return error.response.status
            });

            let stateWallet = await axios.patch(process.env.VUE_APP_BLOCKB_API_URL + 'wallets/personal/', walletData, {
                headers: { Authorization: `Bearer ${this.token}` },
                params: walletData
            })
            .then((response) => {  
                return response.status
            }).catch(error => {
                return error.response.status
            });

            return statePersonal && stateCustomer && stateWallet;
        },
        async updateWallet(walletData) {
            let stateWallet = await axios.patch(process.env.VUE_APP_BLOCKB_API_URL + 'wallets/personal/', walletData, {
                headers: { Authorization: `Bearer ${this.token}` },
                params: walletData
            })
            .then((response) => {  
                return response.status
            }).catch(error => {
                return error.response.status
            });

            return stateWallet;
        },
        async updatePassword(passwordData) {
            var result = await axios.patch(process.env.VUE_APP_BLOCKB_API_URL + 'users/personal/password/', passwordData, {
                headers: { Authorization: `Bearer ${this.token}` },
                params: passwordData
            })
            .then((response) => {  
                return response.data;
            }).catch(error => {
                return false;
            });

            return result;
        },
        async sendFormSupport(supportData) {
            let stateForm = await axios.post(process.env.VUE_APP_BLOCKB_API_URL + 'forms/support/', supportData, {
                timeout: 5000,
                headers: { Authorization: `Bearer ${this.token}` }
            })
            .then((response) => {  
                return response.status
            }).catch(error => {
                return error.response.status
            });

            return stateForm;
        },
        async getTransactions(page = 1, size = 10) {
            let transactions = await axios.post(process.env.VUE_APP_BLOCKB_API_URL + 'transactions/', {page: page, size: size}, {
                timeout: 10000,
                headers: { Authorization: `Bearer ${this.token}` },
                params: {page: page, size: size}
            })
            .then((response) => {  
                return response.data;
            }).catch(error => {
                return error.response.status
            });

            return transactions;
        },
        async getOrders() {
            let data = axios.get(process.env.VUE_APP_BLOCKB_API_URL + 'orders/personal', {
                headers: { Authorization: `Bearer ${this.token}` },
                params: {skip: 0, limit: 100}
            })
            .then((response) => {  
                return response
            }).catch(error => {
                return error
            });

            return data;
        },
        async isAuthenticated() {
             if(this.token != null) {
                return await axios.post(process.env.VUE_APP_BLOCKB_API_URL + 'session', this.token, {
                    timeout: 5000,
                    headers: { Authorization: `Bearer ${this.token}` }
                })
                .then((response) => {
                    if(response.status == 200) {
                        this.user = response.data
                        return true;
                    } else {
                        return false;
                    }
                }).catch(error => {
                    return false;
                });
            } else
                return false;
        },
        logout() {
            this.user = null;
            this.token = null;
            localStorage.removeItem('token');
            router.push('/login');
        }
    }
});